import React from 'react'
import PulseLoader from 'react-spinners/PulseLoader'
import './loader.scss'

const Loader = ({ displayMessage }) => {
  return (
    <div className="overlay">
      <PulseLoader className="spinner" color="white" />
      {displayMessage && <div>Page en cours de chargement</div>}
    </div>
  )
}

export default Loader
